var map = {
	"./justopp/assets/static/icons/justoppIcons/3d-scan.svg": 76352,
	"./justopp/assets/static/icons/justoppIcons/airplay.svg": 32872,
	"./justopp/assets/static/icons/justoppIcons/alarm.svg": 98335,
	"./justopp/assets/static/icons/justoppIcons/align-center-alt.svg": 88624,
	"./justopp/assets/static/icons/justoppIcons/align-center.svg": 9192,
	"./justopp/assets/static/icons/justoppIcons/align-justify-alt.svg": 67489,
	"./justopp/assets/static/icons/justoppIcons/align-justify.svg": 66793,
	"./justopp/assets/static/icons/justoppIcons/align-left-alt.svg": 34847,
	"./justopp/assets/static/icons/justoppIcons/align-left.svg": 97967,
	"./justopp/assets/static/icons/justoppIcons/align-right-alt.svg": 87327,
	"./justopp/assets/static/icons/justoppIcons/align-right.svg": 43113,
	"./justopp/assets/static/icons/justoppIcons/archive.svg": 63198,
	"./justopp/assets/static/icons/justoppIcons/arrow-black.svg": 44722,
	"./justopp/assets/static/icons/justoppIcons/arrow-down-circle.svg": 69083,
	"./justopp/assets/static/icons/justoppIcons/arrow-down-small.svg": 4592,
	"./justopp/assets/static/icons/justoppIcons/arrow-down-square.svg": 94133,
	"./justopp/assets/static/icons/justoppIcons/arrow-down.svg": 53117,
	"./justopp/assets/static/icons/justoppIcons/arrow-download-alt.svg": 39018,
	"./justopp/assets/static/icons/justoppIcons/arrow-download.svg": 18120,
	"./justopp/assets/static/icons/justoppIcons/arrow-left-circle.svg": 23235,
	"./justopp/assets/static/icons/justoppIcons/arrow-left-down.svg": 30115,
	"./justopp/assets/static/icons/justoppIcons/arrow-left-small.svg": 30306,
	"./justopp/assets/static/icons/justoppIcons/arrow-left-square.svg": 29029,
	"./justopp/assets/static/icons/justoppIcons/arrow-left-up.svg": 46163,
	"./justopp/assets/static/icons/justoppIcons/arrow-left.svg": 1643,
	"./justopp/assets/static/icons/justoppIcons/arrow-login-left-alt.svg": 88805,
	"./justopp/assets/static/icons/justoppIcons/arrow-login-left.svg": 96996,
	"./justopp/assets/static/icons/justoppIcons/arrow-login-right-alt.svg": 81670,
	"./justopp/assets/static/icons/justoppIcons/arrow-login-right.svg": 27371,
	"./justopp/assets/static/icons/justoppIcons/arrow-logout-left-alt.svg": 9348,
	"./justopp/assets/static/icons/justoppIcons/arrow-logout-left.svg": 77390,
	"./justopp/assets/static/icons/justoppIcons/arrow-logout-right-alt.svg": 37849,
	"./justopp/assets/static/icons/justoppIcons/arrow-logout-right.svg": 31671,
	"./justopp/assets/static/icons/justoppIcons/arrow-orange.svg": 42233,
	"./justopp/assets/static/icons/justoppIcons/arrow-right-circle.svg": 93736,
	"./justopp/assets/static/icons/justoppIcons/arrow-right-down.svg": 86184,
	"./justopp/assets/static/icons/justoppIcons/arrow-right-small.svg": 63213,
	"./justopp/assets/static/icons/justoppIcons/arrow-right-square.svg": 15454,
	"./justopp/assets/static/icons/justoppIcons/arrow-right-up.svg": 67770,
	"./justopp/assets/static/icons/justoppIcons/arrow-right.svg": 94114,
	"./justopp/assets/static/icons/justoppIcons/arrow-up-circle.svg": 34970,
	"./justopp/assets/static/icons/justoppIcons/arrow-up-small.svg": 79005,
	"./justopp/assets/static/icons/justoppIcons/arrow-up-square.svg": 10723,
	"./justopp/assets/static/icons/justoppIcons/arrow-up.svg": 78098,
	"./justopp/assets/static/icons/justoppIcons/arrow-upload-alt.svg": 26585,
	"./justopp/assets/static/icons/justoppIcons/arrow-upload.svg": 54067,
	"./justopp/assets/static/icons/justoppIcons/arrow-white.svg": 66109,
	"./justopp/assets/static/icons/justoppIcons/arrows-sort.svg": 72621,
	"./justopp/assets/static/icons/justoppIcons/article.svg": 37818,
	"./justopp/assets/static/icons/justoppIcons/bag-alt.svg": 2444,
	"./justopp/assets/static/icons/justoppIcons/bag-plus.svg": 96678,
	"./justopp/assets/static/icons/justoppIcons/bag.svg": 46948,
	"./justopp/assets/static/icons/justoppIcons/bar-code.svg": 2402,
	"./justopp/assets/static/icons/justoppIcons/basket.svg": 35278,
	"./justopp/assets/static/icons/justoppIcons/battery-charging.svg": 73914,
	"./justopp/assets/static/icons/justoppIcons/battery-empty.svg": 34514,
	"./justopp/assets/static/icons/justoppIcons/battery-full.svg": 53693,
	"./justopp/assets/static/icons/justoppIcons/battery-half.svg": 55649,
	"./justopp/assets/static/icons/justoppIcons/bell.svg": 59412,
	"./justopp/assets/static/icons/justoppIcons/binder.svg": 18625,
	"./justopp/assets/static/icons/justoppIcons/bluetooth.svg": 20506,
	"./justopp/assets/static/icons/justoppIcons/book.svg": 4966,
	"./justopp/assets/static/icons/justoppIcons/bookmark.svg": 97464,
	"./justopp/assets/static/icons/justoppIcons/brands-codepen.svg": 87053,
	"./justopp/assets/static/icons/justoppIcons/brands-codesandbox.svg": 62871,
	"./justopp/assets/static/icons/justoppIcons/brands-dribbble.svg": 85611,
	"./justopp/assets/static/icons/justoppIcons/brands-dropbox.svg": 79417,
	"./justopp/assets/static/icons/justoppIcons/brands-facebook.svg": 64878,
	"./justopp/assets/static/icons/justoppIcons/brands-figma.svg": 41230,
	"./justopp/assets/static/icons/justoppIcons/brands-github.svg": 24630,
	"./justopp/assets/static/icons/justoppIcons/brands-google.svg": 14120,
	"./justopp/assets/static/icons/justoppIcons/brands-instagram.svg": 75057,
	"./justopp/assets/static/icons/justoppIcons/brands-linkedin.svg": 44808,
	"./justopp/assets/static/icons/justoppIcons/brands-paypal.svg": 20349,
	"./justopp/assets/static/icons/justoppIcons/brands-snapchat.svg": 56015,
	"./justopp/assets/static/icons/justoppIcons/brands-stripe.svg": 18878,
	"./justopp/assets/static/icons/justoppIcons/brands-twitter.svg": 96377,
	"./justopp/assets/static/icons/justoppIcons/brands-youtube.svg": 94129,
	"./justopp/assets/static/icons/justoppIcons/bug.svg": 56677,
	"./justopp/assets/static/icons/justoppIcons/buyer-benefits.svg": 98258,
	"./justopp/assets/static/icons/justoppIcons/calendar.svg": 23820,
	"./justopp/assets/static/icons/justoppIcons/camera-alt.svg": 72496,
	"./justopp/assets/static/icons/justoppIcons/camera.svg": 50471,
	"./justopp/assets/static/icons/justoppIcons/cart-basket.svg": 95284,
	"./justopp/assets/static/icons/justoppIcons/cart-plus.svg": 17214,
	"./justopp/assets/static/icons/justoppIcons/cart.svg": 91028,
	"./justopp/assets/static/icons/justoppIcons/cart2.svg": 90233,
	"./justopp/assets/static/icons/justoppIcons/cassette.svg": 34375,
	"./justopp/assets/static/icons/justoppIcons/chart-bar-alt.svg": 61444,
	"./justopp/assets/static/icons/justoppIcons/chart-bar.svg": 38665,
	"./justopp/assets/static/icons/justoppIcons/chart-intersect.svg": 53419,
	"./justopp/assets/static/icons/justoppIcons/chart-line.svg": 61028,
	"./justopp/assets/static/icons/justoppIcons/chart-pie.svg": 9747,
	"./justopp/assets/static/icons/justoppIcons/chat-alt.svg": 21645,
	"./justopp/assets/static/icons/justoppIcons/chat-incoming-alt.svg": 4441,
	"./justopp/assets/static/icons/justoppIcons/chat-incoming.svg": 14614,
	"./justopp/assets/static/icons/justoppIcons/chat-message-alt.svg": 54600,
	"./justopp/assets/static/icons/justoppIcons/chat-message.svg": 20738,
	"./justopp/assets/static/icons/justoppIcons/chat.svg": 21533,
	"./justopp/assets/static/icons/justoppIcons/check-circle.svg": 2808,
	"./justopp/assets/static/icons/justoppIcons/check-list.svg": 29625,
	"./justopp/assets/static/icons/justoppIcons/check-square.svg": 98512,
	"./justopp/assets/static/icons/justoppIcons/check.svg": 44895,
	"./justopp/assets/static/icons/justoppIcons/chevron-down.svg": 61115,
	"./justopp/assets/static/icons/justoppIcons/chevron-left.svg": 751,
	"./justopp/assets/static/icons/justoppIcons/chevron-right.svg": 67812,
	"./justopp/assets/static/icons/justoppIcons/chevron-up.svg": 16343,
	"./justopp/assets/static/icons/justoppIcons/chevrons-down.svg": 28922,
	"./justopp/assets/static/icons/justoppIcons/chevrons-left.svg": 43359,
	"./justopp/assets/static/icons/justoppIcons/chevrons-right.svg": 54717,
	"./justopp/assets/static/icons/justoppIcons/chevrons-up.svg": 77147,
	"./justopp/assets/static/icons/justoppIcons/circle-fill.svg": 85447,
	"./justopp/assets/static/icons/justoppIcons/circle-piece.svg": 70163,
	"./justopp/assets/static/icons/justoppIcons/clipboard-check.svg": 58367,
	"./justopp/assets/static/icons/justoppIcons/clipboard-x.svg": 67318,
	"./justopp/assets/static/icons/justoppIcons/clipboard.svg": 36818,
	"./justopp/assets/static/icons/justoppIcons/clock.svg": 56551,
	"./justopp/assets/static/icons/justoppIcons/clone-reverse.svg": 28586,
	"./justopp/assets/static/icons/justoppIcons/clone.svg": 91310,
	"./justopp/assets/static/icons/justoppIcons/cloud-alt.svg": 30013,
	"./justopp/assets/static/icons/justoppIcons/cloud-download.svg": 9284,
	"./justopp/assets/static/icons/justoppIcons/cloud-rain.svg": 94066,
	"./justopp/assets/static/icons/justoppIcons/cloud-upload.svg": 33127,
	"./justopp/assets/static/icons/justoppIcons/cloud.svg": 36503,
	"./justopp/assets/static/icons/justoppIcons/code-arrow-brackets.svg": 66647,
	"./justopp/assets/static/icons/justoppIcons/code.svg": 11878,
	"./justopp/assets/static/icons/justoppIcons/collapse.svg": 36566,
	"./justopp/assets/static/icons/justoppIcons/color-palette.svg": 42825,
	"./justopp/assets/static/icons/justoppIcons/command.svg": 60265,
	"./justopp/assets/static/icons/justoppIcons/contrast.svg": 41594,
	"./justopp/assets/static/icons/justoppIcons/copy-alt-reverse.svg": 91448,
	"./justopp/assets/static/icons/justoppIcons/copy-alt.svg": 18581,
	"./justopp/assets/static/icons/justoppIcons/copy-content-reverse.svg": 99170,
	"./justopp/assets/static/icons/justoppIcons/copy-content.svg": 91554,
	"./justopp/assets/static/icons/justoppIcons/copy-page-reverse.svg": 6230,
	"./justopp/assets/static/icons/justoppIcons/copy-page.svg": 76989,
	"./justopp/assets/static/icons/justoppIcons/copy-reverse.svg": 26057,
	"./justopp/assets/static/icons/justoppIcons/copy.svg": 71252,
	"./justopp/assets/static/icons/justoppIcons/create-profile.svg": 88142,
	"./justopp/assets/static/icons/justoppIcons/credit-cards.svg": 57588,
	"./justopp/assets/static/icons/justoppIcons/crop.svg": 48016,
	"./justopp/assets/static/icons/justoppIcons/cube-multi.svg": 71509,
	"./justopp/assets/static/icons/justoppIcons/cube.svg": 59011,
	"./justopp/assets/static/icons/justoppIcons/dashboard.svg": 9120,
	"./justopp/assets/static/icons/justoppIcons/degree.svg": 30433,
	"./justopp/assets/static/icons/justoppIcons/down-arrow.svg": 31637,
	"./justopp/assets/static/icons/justoppIcons/drop.svg": 53442,
	"./justopp/assets/static/icons/justoppIcons/email.svg": 23474,
	"./justopp/assets/static/icons/justoppIcons/explainer-bottom.svg": 47324,
	"./justopp/assets/static/icons/justoppIcons/export.svg": 94367,
	"./justopp/assets/static/icons/justoppIcons/eye-alt.svg": 65938,
	"./justopp/assets/static/icons/justoppIcons/eye-hidden.svg": 9655,
	"./justopp/assets/static/icons/justoppIcons/eye.svg": 7205,
	"./justopp/assets/static/icons/justoppIcons/facebook.svg": 17213,
	"./justopp/assets/static/icons/justoppIcons/file-copy.svg": 68946,
	"./justopp/assets/static/icons/justoppIcons/file-zip.svg": 46866,
	"./justopp/assets/static/icons/justoppIcons/file.svg": 96226,
	"./justopp/assets/static/icons/justoppIcons/fire.svg": 39796,
	"./justopp/assets/static/icons/justoppIcons/flag.svg": 3656,
	"./justopp/assets/static/icons/justoppIcons/floppy-disk.svg": 15915,
	"./justopp/assets/static/icons/justoppIcons/folder-copy.svg": 85205,
	"./justopp/assets/static/icons/justoppIcons/folder-minus.svg": 89391,
	"./justopp/assets/static/icons/justoppIcons/folder-open-alt.svg": 99668,
	"./justopp/assets/static/icons/justoppIcons/folder-open.svg": 74824,
	"./justopp/assets/static/icons/justoppIcons/folder-plus.svg": 95518,
	"./justopp/assets/static/icons/justoppIcons/folder.svg": 33768,
	"./justopp/assets/static/icons/justoppIcons/footer-chat.svg": 78057,
	"./justopp/assets/static/icons/justoppIcons/footer-mail.svg": 59214,
	"./justopp/assets/static/icons/justoppIcons/footer-video.svg": 81030,
	"./justopp/assets/static/icons/justoppIcons/go-back.svg": 99942,
	"./justopp/assets/static/icons/justoppIcons/go-forward.svg": 10479,
	"./justopp/assets/static/icons/justoppIcons/grid-alt-reverse.svg": 99485,
	"./justopp/assets/static/icons/justoppIcons/grid-alt.svg": 59360,
	"./justopp/assets/static/icons/justoppIcons/grid-reverse.svg": 12233,
	"./justopp/assets/static/icons/justoppIcons/grid.svg": 10794,
	"./justopp/assets/static/icons/justoppIcons/handle-horizontal.svg": 33797,
	"./justopp/assets/static/icons/justoppIcons/handle-vertical.svg": 81210,
	"./justopp/assets/static/icons/justoppIcons/hard-drive.svg": 84791,
	"./justopp/assets/static/icons/justoppIcons/hashtag.svg": 37564,
	"./justopp/assets/static/icons/justoppIcons/headphones.svg": 61298,
	"./justopp/assets/static/icons/justoppIcons/heart.svg": 94260,
	"./justopp/assets/static/icons/justoppIcons/home-appliances.svg": 79955,
	"./justopp/assets/static/icons/justoppIcons/home-entertainment.svg": 83684,
	"./justopp/assets/static/icons/justoppIcons/hotspot-alt.svg": 11622,
	"./justopp/assets/static/icons/justoppIcons/hotspot.svg": 20238,
	"./justopp/assets/static/icons/justoppIcons/image.svg": 53063,
	"./justopp/assets/static/icons/justoppIcons/import.svg": 96862,
	"./justopp/assets/static/icons/justoppIcons/inbox-file.svg": 73132,
	"./justopp/assets/static/icons/justoppIcons/inbox.svg": 84130,
	"./justopp/assets/static/icons/justoppIcons/iphone.svg": 8132,
	"./justopp/assets/static/icons/justoppIcons/it.svg": 60020,
	"./justopp/assets/static/icons/justoppIcons/keyboard-hide.svg": 87329,
	"./justopp/assets/static/icons/justoppIcons/keyboard.svg": 69497,
	"./justopp/assets/static/icons/justoppIcons/kitchen-appliances.svg": 36391,
	"./justopp/assets/static/icons/justoppIcons/laptop.svg": 88615,
	"./justopp/assets/static/icons/justoppIcons/layer-stack.svg": 82291,
	"./justopp/assets/static/icons/justoppIcons/life-float.svg": 81891,
	"./justopp/assets/static/icons/justoppIcons/lightbulb.svg": 69455,
	"./justopp/assets/static/icons/justoppIcons/link-alt.svg": 68071,
	"./justopp/assets/static/icons/justoppIcons/link.svg": 64941,
	"./justopp/assets/static/icons/justoppIcons/linkedin.svg": 84389,
	"./justopp/assets/static/icons/justoppIcons/location.svg": 12950,
	"./justopp/assets/static/icons/justoppIcons/lock-alt.svg": 59000,
	"./justopp/assets/static/icons/justoppIcons/lock.svg": 76178,
	"./justopp/assets/static/icons/justoppIcons/magnify-minus.svg": 52314,
	"./justopp/assets/static/icons/justoppIcons/magnify-plus.svg": 31722,
	"./justopp/assets/static/icons/justoppIcons/magnify.svg": 88621,
	"./justopp/assets/static/icons/justoppIcons/mail-alt.svg": 61210,
	"./justopp/assets/static/icons/justoppIcons/mail.svg": 69606,
	"./justopp/assets/static/icons/justoppIcons/make-deal.svg": 58515,
	"./justopp/assets/static/icons/justoppIcons/map-pin-location-alt.svg": 22767,
	"./justopp/assets/static/icons/justoppIcons/map-pin-location.svg": 35252,
	"./justopp/assets/static/icons/justoppIcons/map-pin.svg": 7046,
	"./justopp/assets/static/icons/justoppIcons/map.svg": 48281,
	"./justopp/assets/static/icons/justoppIcons/maximize.svg": 6680,
	"./justopp/assets/static/icons/justoppIcons/mc-fast-forward.svg": 26853,
	"./justopp/assets/static/icons/justoppIcons/mc-pause.svg": 6371,
	"./justopp/assets/static/icons/justoppIcons/mc-play.svg": 95814,
	"./justopp/assets/static/icons/justoppIcons/mc-repeat-all.svg": 46661,
	"./justopp/assets/static/icons/justoppIcons/mc-repeat-one.svg": 31024,
	"./justopp/assets/static/icons/justoppIcons/mc-repeat.svg": 59782,
	"./justopp/assets/static/icons/justoppIcons/mc-shuffle.svg": 85898,
	"./justopp/assets/static/icons/justoppIcons/mc-skip-back.svg": 38574,
	"./justopp/assets/static/icons/justoppIcons/mc-skip.svg": 87606,
	"./justopp/assets/static/icons/justoppIcons/mc-volume-off.svg": 71166,
	"./justopp/assets/static/icons/justoppIcons/mc-volume.svg": 81054,
	"./justopp/assets/static/icons/justoppIcons/menu-grid.svg": 685,
	"./justopp/assets/static/icons/justoppIcons/mic-off.svg": 21551,
	"./justopp/assets/static/icons/justoppIcons/mic.svg": 76225,
	"./justopp/assets/static/icons/justoppIcons/minimize.svg": 41730,
	"./justopp/assets/static/icons/justoppIcons/minus-circle.svg": 60336,
	"./justopp/assets/static/icons/justoppIcons/minus-square.svg": 22430,
	"./justopp/assets/static/icons/justoppIcons/minus.svg": 2446,
	"./justopp/assets/static/icons/justoppIcons/mobile.svg": 41462,
	"./justopp/assets/static/icons/justoppIcons/monitor.svg": 24413,
	"./justopp/assets/static/icons/justoppIcons/moon.svg": 38566,
	"./justopp/assets/static/icons/justoppIcons/mouse.svg": 75355,
	"./justopp/assets/static/icons/justoppIcons/move.svg": 75394,
	"./justopp/assets/static/icons/justoppIcons/paperclip-alt.svg": 92051,
	"./justopp/assets/static/icons/justoppIcons/paperclip.svg": 56358,
	"./justopp/assets/static/icons/justoppIcons/paragraph.svg": 32292,
	"./justopp/assets/static/icons/justoppIcons/pen-tool.svg": 22415,
	"./justopp/assets/static/icons/justoppIcons/pen.svg": 81787,
	"./justopp/assets/static/icons/justoppIcons/pencil-draw.svg": 902,
	"./justopp/assets/static/icons/justoppIcons/pencil-write.svg": 17775,
	"./justopp/assets/static/icons/justoppIcons/pencil.svg": 1750,
	"./justopp/assets/static/icons/justoppIcons/percent.svg": 14994,
	"./justopp/assets/static/icons/justoppIcons/personal-care.svg": 89438,
	"./justopp/assets/static/icons/justoppIcons/phone-hangup.svg": 39611,
	"./justopp/assets/static/icons/justoppIcons/phone-receiving.svg": 15034,
	"./justopp/assets/static/icons/justoppIcons/phone-ringing.svg": 44439,
	"./justopp/assets/static/icons/justoppIcons/plus-circle.svg": 17396,
	"./justopp/assets/static/icons/justoppIcons/plus-square.svg": 74832,
	"./justopp/assets/static/icons/justoppIcons/plus.svg": 98401,
	"./justopp/assets/static/icons/justoppIcons/print.svg": 79178,
	"./justopp/assets/static/icons/justoppIcons/purchase-method.svg": 51366,
	"./justopp/assets/static/icons/justoppIcons/qr-code.svg": 49147,
	"./justopp/assets/static/icons/justoppIcons/question.svg": 77873,
	"./justopp/assets/static/icons/justoppIcons/redo-alt.svg": 14960,
	"./justopp/assets/static/icons/justoppIcons/redo.svg": 75691,
	"./justopp/assets/static/icons/justoppIcons/refresh.svg": 18984,
	"./justopp/assets/static/icons/justoppIcons/resize-alt-reverse.svg": 644,
	"./justopp/assets/static/icons/justoppIcons/resize-alt.svg": 10924,
	"./justopp/assets/static/icons/justoppIcons/resize-reverse.svg": 46769,
	"./justopp/assets/static/icons/justoppIcons/resize.svg": 15192,
	"./justopp/assets/static/icons/justoppIcons/rss.svg": 93157,
	"./justopp/assets/static/icons/justoppIcons/scan.svg": 87172,
	"./justopp/assets/static/icons/justoppIcons/search-deal.svg": 16529,
	"./justopp/assets/static/icons/justoppIcons/search.svg": 40534,
	"./justopp/assets/static/icons/justoppIcons/seller-benefits.svg": 46776,
	"./justopp/assets/static/icons/justoppIcons/send-alt.svg": 41666,
	"./justopp/assets/static/icons/justoppIcons/send.svg": 62323,
	"./justopp/assets/static/icons/justoppIcons/server-alt.svg": 47205,
	"./justopp/assets/static/icons/justoppIcons/server-cloud.svg": 46227,
	"./justopp/assets/static/icons/justoppIcons/server.svg": 40777,
	"./justopp/assets/static/icons/justoppIcons/settings.svg": 4788,
	"./justopp/assets/static/icons/justoppIcons/shape-circle.svg": 3920,
	"./justopp/assets/static/icons/justoppIcons/shape-square.svg": 34590,
	"./justopp/assets/static/icons/justoppIcons/shape-triangle.svg": 22961,
	"./justopp/assets/static/icons/justoppIcons/shapes.svg": 68647,
	"./justopp/assets/static/icons/justoppIcons/share.svg": 75684,
	"./justopp/assets/static/icons/justoppIcons/shield-check.svg": 86422,
	"./justopp/assets/static/icons/justoppIcons/shield-hidden.svg": 42026,
	"./justopp/assets/static/icons/justoppIcons/shield-x.svg": 87164,
	"./justopp/assets/static/icons/justoppIcons/shield.svg": 96612,
	"./justopp/assets/static/icons/justoppIcons/sliders-alt-horizontal.svg": 11231,
	"./justopp/assets/static/icons/justoppIcons/sliders-alt-vertical.svg": 59676,
	"./justopp/assets/static/icons/justoppIcons/sliders-horizontal.svg": 7776,
	"./justopp/assets/static/icons/justoppIcons/sliders-vertical.svg": 67461,
	"./justopp/assets/static/icons/justoppIcons/social-facebook.svg": 49592,
	"./justopp/assets/static/icons/justoppIcons/speaker.svg": 76345,
	"./justopp/assets/static/icons/justoppIcons/star-fill.svg": 60996,
	"./justopp/assets/static/icons/justoppIcons/star.svg": 57192,
	"./justopp/assets/static/icons/justoppIcons/stopwatch.svg": 53502,
	"./justopp/assets/static/icons/justoppIcons/sun.svg": 79745,
	"./justopp/assets/static/icons/justoppIcons/terminal-alt.svg": 20762,
	"./justopp/assets/static/icons/justoppIcons/terminal.svg": 63405,
	"./justopp/assets/static/icons/justoppIcons/thumbs-down.svg": 10320,
	"./justopp/assets/static/icons/justoppIcons/thumbs-up.svg": 26467,
	"./justopp/assets/static/icons/justoppIcons/trash-alt.svg": 90384,
	"./justopp/assets/static/icons/justoppIcons/trash.svg": 18264,
	"./justopp/assets/static/icons/justoppIcons/undo-alt.svg": 51261,
	"./justopp/assets/static/icons/justoppIcons/undo.svg": 37308,
	"./justopp/assets/static/icons/justoppIcons/unlock-alt.svg": 74020,
	"./justopp/assets/static/icons/justoppIcons/unlock.svg": 40299,
	"./justopp/assets/static/icons/justoppIcons/user-login.svg": 72740,
	"./justopp/assets/static/icons/justoppIcons/user-minus-alt.svg": 98223,
	"./justopp/assets/static/icons/justoppIcons/user-minus.svg": 23939,
	"./justopp/assets/static/icons/justoppIcons/user-plus-alt.svg": 18454,
	"./justopp/assets/static/icons/justoppIcons/user-plus.svg": 39917,
	"./justopp/assets/static/icons/justoppIcons/user.svg": 83265,
	"./justopp/assets/static/icons/justoppIcons/users.svg": 64584,
	"./justopp/assets/static/icons/justoppIcons/video-off.svg": 82787,
	"./justopp/assets/static/icons/justoppIcons/video.svg": 32737,
	"./justopp/assets/static/icons/justoppIcons/voicemail.svg": 38056,
	"./justopp/assets/static/icons/justoppIcons/wallet.svg": 37940,
	"./justopp/assets/static/icons/justoppIcons/warning-circle.svg": 37355,
	"./justopp/assets/static/icons/justoppIcons/warning-triangle.svg": 17004,
	"./justopp/assets/static/icons/justoppIcons/watch.svg": 65644,
	"./justopp/assets/static/icons/justoppIcons/wifi-disabled.svg": 21153,
	"./justopp/assets/static/icons/justoppIcons/wifi.svg": 93302,
	"./justopp/assets/static/icons/justoppIcons/x-circle.svg": 1987,
	"./justopp/assets/static/icons/justoppIcons/x-square.svg": 25367,
	"./justopp/assets/static/icons/justoppIcons/x.svg": 75946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76417;